import styled from "styled-components";
export const StarsAndSoldBox = styled.div `
	display: flex;
	align-items: center;
	height: 16px;
	font-size: 12px;
	line-height: 16px;
	color: #999;
`;
export const LeftStar = styled.span `
	display: flex;
	align-items: center;
	text-align: left;
	flex: 1;
	gap: 2px;
`;
export const LeftStarNum = styled.span `
	margin-left: 3px;
`;
export const RightSold = styled.span `
	text-align: ${(props) => {
    return (props === null || props === void 0 ? void 0 : props.hasStar) ? "right" : "left";
}};
	flex: 1;
`;
